module.exports = __webpack_public_path__ + "media/warning1.2c405a25.wav";